import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Featurette from "./featurette"

const Customers = () => {
  const customers = useStaticQuery(graphql`
    query Customers {
      allMarkdownRemark(
        sort: { fields: frontmatter___order }
        filter: {
          frontmatter: { type: { eq: "customer" }, visible: { eq: true } }
        }
      ) {
        totalCount
        edges {
          node {
            id
            frontmatter {
              name
              industry
              image {
                ...FeaturetteImage
              }
            }
            html
          }
        }
      }
    }
  `)
  return (
    <>
      {customers.allMarkdownRemark.totalCount === 0 && (
        <p>
          We are currently awaiting permission from our clients before
          publishing any of our work.
        </p>
      )}
      {customers.allMarkdownRemark.edges.map(({ node }, index) => (
        <Featurette
          key={node.id}
          title={node.frontmatter.name}
          subtitle={node.frontmatter.industry}
          image={node.frontmatter.image}
          html={node.html}
          primaryTeamMember={null}
          secondaryTeamMember={null}
          index={index}
        />
      ))}
    </>
  )
}

export default Customers
